import { BASE_V2_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'NODES_GET',
  GET_SUCCESS: 'NODES_GET_SUCCESS',
  GET_FAILURE: 'NODES_GET_FAILURE',
  INVALIDATE_ITEM: 'NODES_INVALIDATE_ITEM',
  GET_ALL: 'NODES_GET_ALL',
  GET_ALL_SUCCESS: 'NODES_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'NODES_GET_ALL_FAILURE',
  POST: 'NODES_POST',
  POST_SUCCESS: 'NODES_POST_SUCCESS',
  POST_FAILURE: 'NODES_POST_FAILURE',
  PATCH: 'NODES_PATCH',
  PATCH_SUCCESS: 'NODES_PATCH_SUCCESS',
  PATCH_FAILURE: 'NODES_PATCH_FAILURE',
};

export const get = actions.get(nodeId => `${BASE_V2_URL}/nodes/${nodeId}/`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const getAll = actions.getAll(
  chapterId => `${BASE_V2_URL}/chapters/${chapterId}/nodes/`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post((id, value) => `${BASE_V2_URL}/drafts/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const patch = actions.patch(nodeId => `${BASE_V2_URL}/nodes/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
